
// Aricle Categories
const aricleCategories = {
  AccountantAndBookkeepers:{
    image: {
      path: "help-and-support--accountant-icon",
      alt: "help-and-support--accountant-icon",
    },
    title: "Accountant & Bookkeepers",
    slug: "accountant-and-bookkeepers",
    icon:'article-accountant--icon',
    description: `We're here to assist you with all your account related needs`,
    subCategories: {
      clientManagement:{
        slug: "client-management",
        title: `Client Management`,
       description: `Manage all client entities and jobs from a single dashboard.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
       clientOnboarding:{
        slug: "client-onboarding",
        title: `Client Onboarding`,
        description: `Onboard new clients with compliance and data collection tools.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
       clientVerification:{
        slug: "client-verification",
        title: "Client Verification",
         description: `Your client verification just got simpler. Synkli helps tax agents securely collect client IDs`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
      collateDocuments:{
        slug: "collate-documents",
        title: "Collate Documents",
        description: `Gather client files automatically across jobs and folders securely.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
      deedBuilder:{
        slug: "deed-builder",
        title: "Deed Builder",
        description: `Create company, trust and entity formation documents.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
      ethicalClearance:{
        slug: "ethical-clearance",
        title: "Ethical Clearance",
        description: `Run ethical checks before client onboarding or engagements.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
     emailManager:{
        title: "Email Manager",
        slug: "email-manager",
        description: `Maintain your emails with clients, jobs and documents.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
      documentHub:{
        slug: "document-hub",
        title: `Document Hub`,
        description: `Upload and manage receipts, invoices and income records.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
      xeroPracticeManager:{
        slug: "xero-practice-manager",
        title: `XPM Integration`,
        description:'Automate client and job data with Synkli’s XPM integration—streamlining workflows with accuracy and efficiency.',
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      }
    },
  },
  SynkliAppUsers:{
    image: {
      path: "help-and-support--synkli-app-icon",
      alt: "help-and-support--synkli-app-icon",
    },
    title: "Synkli App Users",
    slug: "synkli-app-users",
    icon:'article-synkli-app-user--icon',
    description: `Integrate Synkli with your other systems`,
    subCategories: {
      milageTracker:{
        slug: "milage-tracker",
        title: `Mileage Tracking`,
        description: `Record work-related vehicle trips for mileage claims.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
       expenseAndIncomeManagement:{
        slug: "expense-and-income-management",
        title: "Expense and Income Management",
        description: `Monitor your earnings, costs and financial activity.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
       jobManager:{
        slug: "job-manager",
        title: `Job Manager`,
        description: `Manage client jobs, tasks, lodgements and due dates.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
    },
  },
   SynkliWebUsers:{
    image: {
      path: "help-and-support--synkli-web-users-icon",
      alt: "help-and-support--synkli-web-users-icon",
    },
    title: "Synkli Web Users ",
    slug: "synkli-web-users",
    description: `We're here to assist you with all your subscription needs.`,
    icon:'article-synkli-web-user--icon',
    subCategories: {
      agentNominationWizard:{
        slug: "ato-mygovid-gdpr-compliant-agent-nomination",
        title: `Agent Nomination Wizard`,
        description: `Authorise or update your registered tax or BAS agent.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
       multipleProfilesManagement:{
        slug: "multiple-profiles-management",
        title: `Multiple Profile Manager`,
        description: `Manage linked businesses and switch between ABNs.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
      documentHub:{
        slug: "document-hub",
        title: `Document Hub`,
        description: `Upload and manage receipts, invoices and income records.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
       claimDeductions:{
        slug: "claim-deductions",
        title: `Claim Deduction`,
        description: `Estimate claimable expenses for your business operations.`,
        image: {
          path: "help-and-support--account-icon",
          alt: "help-and-support--account-icon",
        },
      },
    },
  },
}


module.exports = {
  aricleCategories
}